<app-share-button ></app-share-button>

<div class="row">
    <div class="col-md-8  ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>
                    </h2>
                </div>
                <div class="col-md-2 col2 "> <a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>  
                </div>
                <!-- <div class="col-md-2 col2"><button class="btn share"><img src="./assets/share (5).svg"
                            style="width: 30px;" alt=""></button>
                </div> -->
                <div class="col-md-12" (mouseover)="showpayment(true,'1')" (mouseout)="showpayment(false,'1')" id="1">

                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                    id="2">
                    <h2>PayG के रेसलर्स के लिए ऑनबोर्डिंग प्रोसेस  </h2>
                    <label for="" class="mt-2">PayG पर रेसलर्स के लिए ऑनबोर्डिंग प्रोसेस इस तरह से डिज़ाइन किया गया है, ताकि वे हमारी पेमेंट गेटवे सर्विसेज़ से आसानी से जुड़ सकें, साथ ही सभी नियमों का पालन करते हुए अपने क्लाइंट्स को अच्छे से सर्व कर सकें। नीचे हमने हर एक स्टेप को विस्तार से बताया है। </label>
                </div>
                <div class="col-md-12 mt-5  " (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id="3">


                    <h4 class="mt-4">स्टेप 1: शुरुआत में रजिस्ट्रेशन  </h4>
                    <label for="">1.वेबसाइट पर जाएं
                    </label><br>
                    <label for="">सबसे पहले, हमारी आधिकारिक वेबसाइट  पर जाएं।  <a style="color: #09BCE1;" href="https://payg.in/">www.payg.in</a> </label>

                    <div class="row">
                        <div class="col-md-12 mt-3 " style="text-align: center;">
                            <img src="./assets/visitourweb.png" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label class="mt-2">2.लॉगिन या रजिस्टर करें</label><br>
                    <label for="">"Login" बटन पर क्लिक करें, फिर "Reseller" ऑप्शन को चुनें। अगर आप नए यूज़र हैं, तो "Register as Reseller" पर क्लिक करें। </label><br>

                    <div class="row">
                        <div class="col-md-12 mt-3 " style="text-align: center;">
                            <img src="./assets/loginreg.jpg" width="100%" height="100%" alt="">
                        </div>
                    </div>


                </div>
                <h4 class="mt-4"><b>स्टेप 2: रजिस्ट्रेशन डिटेल्स भरना </b></h4>
                <label for="">1.बेसिक जानकारी भरें </label>
                <ul style="padding: 1% 0% 1% 6%;">
                    <li> नाम </li>
                    <li>ईमेल पता</li>
                    <li>मोबाइल नंबर</li>
                    <li>कंपनी का नाम </li>
                    <li>पैन कार्ड  </li>
                </ul>
                <label for="">सभी जानकारी भरने के बाद, "Register" बटन पर क्लिक करें। 
                </label>

                <div class="row">
                    <div class="col-md-12 mt-3">
                        <img src="./assets/basicinfo.jpg" width="100%" height="100%" alt="">
                    </div>
                </div>


                <label for="" class="mt-3">2. OTP वेरिफिकेशन </label>
                <label for="">-अपने रजिस्टर्ड मोबाइल नंबर पर भेजे गए OTP को दर्ज करें </label>


                <div class="row">
                    <div class="col-md-12 mt-3">
                        <img src="./assets/otphere.jpg" width="100%" height="100%" alt="">
                    </div>
                </div>

                <label for="" class="mt-3"> - अपने अकाउंट के लिए एक मजबूत पासवर्ड बनाएं। </label>


                <div class="row">
                    <div class="col-md-12 mt-3">
                        <img src="./assets/strongpass.png" width="100%" height="100%" alt="">
                    </div>
                </div>

                <h4 class="mt-4"><b>स्टेप 3: बिजनेस जानकारी </b></h4>
                <label for="">1. बिजनेस का पता 
                    </label>
                <p> -अपने बिजनेस का पूरा पता दें, जिसमें शामिल हो: </p>
                <p>- राज्य </p>
                <p> -  पिन कोड </p>
                <p> -   शहर का नाम  </p>
                <div class="row">
                    <div class="col-md-12 mt-3">
                        <img src="./assets/Screenshot 2024-11-04 191719.png" width="100%" height="100%"
                            alt="">
                    </div>
                </div>

                <label for="" class="mt-3">2.बिजनेस डिटेल्स</label>
                <p>- अतिरिक्त बिजनेस जानकारी भरें, जैसे:</p>
                <p> -कंपनी का नाम </p>
                <p> - वार्षिक टर्नओवर </p>
                <p> - वेबसाइट URL  </p>
                <p> - कंपनी का पैन नंबर </p>
                <div class="row">
                    <div class="col-md-12 mt-3">
                        <img src="./assets/Screenshot 2024-11-04 144859.png" width="100%" height="100%"
                            alt="">
                    </div>
                </div>

                <label for="" class="mt-3">3.स्वामी की जानकारी </label>
                <p> - कंपनी के मालिक की जानकारी भरें, जिसमें शामिल हो:</p>
                <p> - नाम  </p>
                <p> - संपर्क जानकारी</p>
                <p> -यह स्टेप बिजनेस की वास्तविकता की पुष्टि करने के लिए बेहद महत्वपूर्ण है।  </p>
                <div class="row">
                    <div class="col-md-12 mt-3">
                        <img src="./assets/Screenshot 2024-11-04 144928.png" width="100%" height="100%"
                            alt="">
                    </div>
                </div>



                <label for="" class="mt-3">4:बैंक विवरण </label>
                <label>1. Bank Information </label>
                <p> - बैंक की जानकारी प्रदान करें, जहां फंड्स सेट्ल होंगे, जिसमें शामिल हो:  </p>
                <p> -बैंक का नाम  </p>
                <p> -खाता नंबर   </p>
                <p> -IFSC कोड  </p>
                <div class="row">
                    <div class="col-md-12 mt-3">
                        <img src="./assets/Screenshot 2024-11-04 144949.png" width="100%" height="100%"
                            alt="">
                    </div>
                </div>

                <label for="" class="mt-3"> 5:दस्तावेज़ अपलोड     </label>
                <label>1.दस्तावेज़ सबमिशन  </label>
                <p> - अपनी आवेदन को सपोर्ट करने के लिए आवश्यक दस्तावेज़ अपलोड करें। इसमें शामिल हो सकते हैं:</p>
                <p> - बिजनेस रजिस्ट्रेशन सर्टिफिकेट</p>
                <p> -पैन कार्ड  </p>
                <p> - पते का प्रमाण </p>
                <p>- बैंक स्टेटमेंट   </p>
                <p> -सुनिश्चित करें कि सभी दस्तावेज़ स्पष्ट और पढ़ने योग्य हों ताकि वेरिफिकेशन में कोई परेशानी न हो। </p>
                <div class="row">
                    <div class="col-md-12 mt-3">
                        <img src="./assets/Screenshot 2024-11-04 145016.png" width="100%" height="100%"
                            alt="">
                    </div>
                </div>

                <h4 class="mt-4"><b>स्टेप 4: रजिस्ट्रेशन पूरा करना  </b></h4>
                <label for="">1. रजिस्ट्रेशन कंफर्मेशन </label>
                <p>- जब सारी जानकारी भर दी जाए और दस्तावेज़ अपलोड कर दिए जाएं, तो आपका रजिस्ट्रेशन प्रोसेस किया जाएगा।
                </p>

                <div class="row">
                    <div class="col-md-12 mt-3">
                        <img src="./assets/Screenshot 2024-11-04 191331.png" width="100%" height="100%"
                            alt="">
                    </div>
                </div>
                <p class="mt-3"> - आपको आपके आवेदन की स्थिति के बारे में एक कंफर्मेशन नोटिफिकेशन मिलेगा।  </p>
                <label for="">2.दस्तावेज़ वेरिफिकेशन  </label>
                <p> - PayG की टीम आपके द्वारा अपलोड किए गए दस्तावेज़ की समीक्षा और वेरिफाई करेगी। यह स्टेप नियमों के पालन और वास्तविकता को सुनिश्चित करने के लिए महत्वपूर्ण है। </p>


                <h4 class="mt-4"><b>स्टेप 5: अकाउंट सक्रियकरण  </b></h4>
                <h4>1.अपने अकाउंट में लॉगिन करें</h4>
                <p>-दस्तावेज़ की सफल वेरिफिकेशन के बाद, आपको आपके रजिस्ट्रेशन की स्वीकृति की पुष्टि करने वाला नोटिफिकेशन मिलेगा।
                </p>
                <p>  -अब आप अपने रजिस्टर्ड क्रेडेंशियल्स का उपयोग करके अपने अकाउंट में लॉगिन कर सकते हैं। </p>
                <div class="col-md-12 mt-3">
                    <img src="./assets/Screenshot 2024-11-04 191519.png" width="100%" height="100%" alt="">
                </div>


                <label for="" class="mt-3">लॉगिन करने के बाद, आपको हमारी पेमेंट सॉल्यूशंस, APIs और अन्य संसाधनों तक पहुंच मिल जाएगी, जो इंटीग्रेशन और ऑपरेशन के लिए आवश्यक हैं। </label>
                <label for="">इन स्टेप्स का पालन करके, रेसलर्स PayG के साथ आसानी से ऑनबोर्ड हो सकते हैं और हमारी पेमेंट सॉल्यूशंस का उपयोग करके अपने बिजनेस को बढ़ा सकते हैं और अपने क्लाइंट्स को प्रभावी तरीके से सर्व कर सकते हैं। </label>




            </div>
        </div>
    </div>
    <div class="col-md-4 hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        विषयसूची:                      </h5>

                </div>
                <div class="col-md-12 mt-2">
                    <!-- <a href="#1">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                    alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span class="videoHover" style="cursor: pointer;"
                                    [ngClass]="{'video':colors=='1'}" (click)="color('1')"
                                    >
                                    Introduction to
                                    Payment Gateways
                                </span>
                              
                            </div>
                        </div>
                    </a> -->
                </div>
                <div class="col-md-12 ">
                    <a href="#2">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                    (click)="color('2')">परिचय </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#3">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')">
                                    पंजीकरण प्रक्रिया </span>

                            </div>
                        </div>
                    </a>
                </div>
                <!-- <div class="col-md-12 ">
                    <a href="#4">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                    (click)="color('4')">Benefits of Being a Reseller </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#5">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='5'}"
                                    (click)="color('5')"> How Resellers Can Benefit from PayG</span>

                            </div>
                        </div>
                    </a>
                </div> -->

            </div>
        </div>
    </div>



    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8">
                <a [routerLink]="['/introduction-reseller']"><button class="btn btn-color"
                        (click)="menues('Creating Profile')"> <img src="./assets/Arrow 3.svg" alt=""> &nbsp;
                        परिचय

                        &nbsp;</button></a>

            </div>
            <div class="col-md-4 ">
                <a [routerLink]="['/login-with-qr']"> <button class="btn btn-color">QR से लॉगिन करें
                        &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
            </div>
        </div>
    </div>
</div>